<div class="termos-overlay">
  <div class="termos-backdrop"></div>

  <div class="termos-dialog">
    <div class="termos-header">
      <div class="termos-logo-area">
        <i class="ri-leaf-line termos-icon"></i>
        <div>
          <h4 class="termos-title mb-0">Termo de Consentimento</h4>
          <p class="termos-subtitle mb-0">Lei de Proteção de Dados</p>
        </div>
        @if (modoConsulta) {
          <button type="button" class="btn-close ms-auto" aria-label="Fechar termos" (click)="onFecharConsulta()"></button>
        }
      </div>
    </div>

    <div class="termos-body">
      <div class="termos-scroll">
        <section class="termos-section">
          <h6>1. Sobre a plataforma</h6>
          <p>
            A plataforma eletrônica Lista de Espécies Ameaçadas da Flora e Fauna do Estado de Minas Gerais foi
            desenvolvida para possibilitar a participação da sociedade civil na indicação de espécies da fauna e
            flora do Estado de Minas Gerais que possam ser priorizadas para avaliação de risco de extinção.
          </p>
          <p>
            Este documento informa como seus dados pessoais serão tratados, em conformidade com a Lei no
            13.709/2018 (LGPD). Ao preencher este formulário, você declara estar ciente e concordar com as
            condições.
          </p>
        </section>

        <section class="termos-section">
          <h6>2. Participação e dados coletados</h6>
          <p>
            A participação na plataforma é voluntária e colaborativa, permitindo que os usuários contribuam com
            opiniões, sugestões e informações relacionadas à biodiversidade.
          </p>
          <p>
            Seus dados, como nome, e-mail e filiação institucional, fornecidos de forma espontânea, serão
            coletados exclusivamente para identificação da autoria das informações técnicas e científicas
            fornecidas para a lista de espécies, comunicação direta entre a coordenação do projeto e o colaborador
            para validação de dados e registro histórico e acadêmico da colaboração técnica.
          </p>
          <p>
            Nesse contexto, também poderão ser coletados o conteúdo das contribuições inseridas pelos usuários e
            dados técnicos de acesso, como endereço IP, data e hora de utilização e informações sobre o dispositivo
            utilizado.
          </p>
        </section>

        <section class="termos-section">
          <h6>3. Uso dos dados</h6>
          <p>
            Os dados coletados serão utilizados exclusivamente para viabilizar e qualificar o processo
            participativo, permitindo o registro, a organização e a análise das contribuições da sociedade civil,
            bem como para subsidiar processos técnicos e científicos voltados à priorização de espécies e ao
            fortalecimento de iniciativas de conservação da biodiversidade.
          </p>
        </section>

        <section class="termos-section">
          <h6>4. Proteção e compartilhamento</h6>
          <p>
            Comprometemo-nos a adotar medidas técnicas e administrativas para proteger seus dados contra acessos
            não autorizados ou situações acidentais de perda ou alteração.
          </p>
          <p>
            O tratamento seguirá os princípios de necessidade, com coleta apenas do mínimo de dados necessários
            para o projeto; transparência, com informações claras sobre o uso dos dados; e não discriminação, sem
            utilização para fins discriminatórios ilícitos.
          </p>
          <p>
            Não haverá uso compartilhado de seus dados pessoais com terceiros para fins econômicos. Caso o projeto
            exija a transferência para outros órgãos de pesquisa, isso será feito garantindo a segurança da
            informação e as finalidades aqui descritas.
          </p>
        </section>

        <section class="termos-section">
          <h6>5. Direitos e declaração de ciência</h6>
          <p>
            O titular dos dados poderá, a qualquer momento, exercer seus direitos, incluindo a confirmação da
            existência de tratamento, o acesso aos dados, a correção de informações incompletas ou desatualizadas,
            a solicitação de anonimização ou exclusão, bem como a revogação do consentimento, mediante contato com
            o responsável pelo tratamento de dados por meio do canal disponibilizado na plataforma.
          </p>
          <p>
            Ao prosseguir com o preenchimento deste formulário, você fornece seu consentimento livre, informado e
            inequívoco para o tratamento de seus dados pessoais para as finalidades acima listadas, nos termos do
            Art. 7o, inciso I, da LGPD.
          </p>
          <p>Declaração de ciência e consentimento:</p>
          <ul class="mb-0 ps-3">
            <li>
              Declaro que li e compreendi a Política de Privacidade acima e estou ciente sobre a forma como meus
              dados pessoais poderão ser coletados, utilizados e tratados.
            </li>
            <li>
              Concordo, de forma livre, informada e inequívoca, com o tratamento dos dados pessoais por mim
              fornecidos, para as finalidades descritas neste documento.
            </li>
            <li>
              Declaro que as informações fornecidas são de minha responsabilidade e que não inserirei dados
              pessoais de terceiros sem a devida autorização.
            </li>
            <li>
              Estou ciente de que posso, a qualquer momento, exercer meus direitos como titular de dados, conforme
              previsto na legislação vigente.
            </li>
          </ul>
        </section>
        @if (modoConsulta) {
          <section class="termos-section" aria-live="polite">
            <h6>Status do aceite</h6>
            @if (aceiteRegistrado) {
              <p>Termos aceitos@if (dataAceite) { em {{ dataAceite | date: 'dd/MM/yyyy HH:mm' }} }.</p>
            } @else {
              <p>Termos não aceitos.</p>
            }
          </section>
        }
      </div>
    </div>

    @if (!modoConsulta) {
    <div class="termos-footer">
      <div class="termos-check-area">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="aceitouTermosCheck"
            [(ngModel)]="aceitouTermos"
          />
          <label class="form-check-label" for="aceitouTermosCheck">
            Li e concordo com o termo de consentimento acima
          </label>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-success termos-btn"
        [disabled]="!aceitouTermos || confirmando"
        (click)="onConfirmar()"
      >
        @if (confirmando) {
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          Confirmando...
        } @else {
          <i class="ri-checkbox-circle-line me-1"></i>
          Confirmar e Continuar
        }
      </button>
    </div>
    }
  </div>
</div>
